import { createContext, useState } from 'react'
import {
  GetAllDataCustomReport,
  CxpCustomReportById,
  DownloadCxpCustomReports,
  DownloadCxpCustomReportsPdf,
  ScheduleCustomReport,
  filterUrl
} from 'src/configs/api'
import { useAPI } from 'src/utils/api'
import { useToast } from 'src/@core/components/custom-Toast/customToast'
const defaultProvider = {
  reportId: '',
  setReportId: () => null,
  reportName: '',
  setReportName: () => null,
  reportDescription: '',
  setReportDescription: () => null,
  reportQuery: '',
  setReportQuery: () => null,
  queryData: '',
  setQueryData: () => null,
  headersType: '',
  setHeadersType: () => null,
  headers: [],
  setHeaders: () => null,
  message: '',
  setMessage: () => null,
  reportsData: [],
  setReportsData: () => null,
  customReportDetails: {},
  setCustomReportDetails: () => null,
  reportsCount: 0,
  setReportsCount: () => null,
  reportFilterList: [],
  setReportFilterList: () => null,
  reportOtherFilterList: [],
  setReportOtherFilterList: () => null,
  hasTagFilter: false,
  setHasTagFilter: () => null,
  scheduleCustomReport: async () => null
}

const CustomReportContext = createContext(defaultProvider)

const CustomReportProvider = ({ children }) => {
  const [reportId, setReportId] = useState(defaultProvider.reportId)
  const [reportName, setReportName] = useState(defaultProvider.reportName)
  const [reportDescription, setReportDescription] = useState(defaultProvider.reportDescription)
  const [reportQuery, setReportQuery] = useState(defaultProvider.reportQuery)
  const [queryData, setQueryData] = useState(defaultProvider.queryData)
  const [headersType, setHeadersType] = useState(defaultProvider.headersType)
  const [headers, setHeaders] = useState(defaultProvider.headers)
  const [message, setMessage] = useState(defaultProvider.message)
  const [reportsData, setReportsData] = useState(defaultProvider.reportsData)
  const [reportsCount, setReportsCount] = useState(defaultProvider.reportsCount)
  const [customReportDetails, setCustomReportDetails] = useState(defaultProvider.customReportDetails)
  const [reportFilterList, setReportFilterList] = useState(defaultProvider.reportFilterList)
  const [reportOtherFilterList, setReportOtherFilterList] = useState(defaultProvider.reportOtherFilterList)
  const [hasTagFilter, setHasTagFilter] = useState(defaultProvider.hasTagFilter)

  const api = useAPI()
  const {showError,showSuccess}= useToast()

  // Function to fetch the custom reports
  const fetchCustomReports = async (payload) => {
    try {
      const response = await api.post(`${GetAllDataCustomReport}/search`, payload)
      setReportsData(response?.data?.reports || [])
      setReportsCount(response?.data?.total || 0)
      setMessage('Custom reports fetched successfully')
    } catch (error) {
      // console.error('Error fetching custom reports:', error)
      setMessage(error.response?.data?.message || 'An error occurred')
    }
  }

  const getReportFilterList = async () => {
    try {
      const response = await api.get(`${filterUrl}/reports`)

      const filters = response?.data?.data?.filters || []
      const otherFilters = response?.data?.data?.otherFilters || []

      const tagsFilter = filters.find(f => f.key === 'tags')
      setHasTagFilter(!!tagsFilter)
      setReportFilterList(tagsFilter ? tagsFilter.options.map(o => o.value) : [])
      setReportOtherFilterList(otherFilters)

      const initialSelectedFilters = {}
      otherFilters.forEach(f => {
        initialSelectedFilters[f.key] = []
      })

      return initialSelectedFilters
    } catch {
      setReportFilterList([])
      setReportOtherFilterList([])
      return {}
    }
  }

  const getCustomReportData = async id => {
    try {
      const apiUrl = CxpCustomReportById.replace(':reportId', id)
      const response = await api.get(
        apiUrl
        
      )
      setCustomReportDetails(response?.data)
    } catch {
    }
  }
const bulkDeleteCustomReport = async selectedRows => {
  try {
    const response = await api.delete(
      `${GetAllDataCustomReport}/bulk`,
      {
        data: {
          reportIds: selectedRows
        }
      }
    )

    if (
      response?.status === 200 ||
      response?.status === 204
    ) {
      showSuccess('Reports deleted successfully')
      //getCustomReports()
      //setSelectedRows([])
    }
  } catch {
    showError('Failed to delete reports')
  }
}
  const downloadCustomReportCsv = async id => {
    try {

      const apiUrl = DownloadCxpCustomReports.replace(':reportId', id)
      const response = await api.get(apiUrl, {
       
        responseType: 'blob'
      })
      const disposition = response?.headers['content-disposition']
      let filename = 'report.csv'
      if (disposition) {
        const matches = /filename="([^"]*)"/.exec(disposition)

        if (matches && matches[1]) {
          filename = matches[1]
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      showSuccess(`${filename} downloaded successfully`)
    } catch {
      // console.error('Failed to download the report:', error)
    }
  }

  const scheduleCustomReport = async (scheduleReportId, payload) => {
    try {
      const apiUrl = ScheduleCustomReport.replace(':reportId', scheduleReportId)
      const response = await api.put(apiUrl, payload)
      return response?.data
    } catch (error) {
      throw error
    }
  }

  const downloadCustomReportPdf = async id => {

    try {

      const apiUrl = DownloadCxpCustomReportsPdf.replace(':reportId', id) // Change the API endpoint to the one for PDF

      const response = await api.get(apiUrl, {
        
        responseType: 'blob' // We expect the PDF to be in blob format
      })
      const disposition = response?.headers['content-disposition']
      let filename = 'report.pdf'

      if (disposition) {
        const matches = /filename="([^"]*)"/.exec(disposition)

        if (matches && matches[1]) {
          filename = matches[1]
        }
      }
      const url = window.URL.createObjectURL(new Blob([response?.data], { type: 'application/pdf' })) // Set the type to 'application/pdf'

      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', filename) // Use the filename extracted or default
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      showSuccess(`${filename} downloaded successfully`)
    } catch {
      // console.error('Failed to download the report:', error)
    }
  }

  const values = {
    reportId,
    setReportId,
    reportName,
    setReportName,
    reportDescription,
    setReportDescription,
    reportQuery,
    setReportQuery,
    queryData,
    setQueryData,
    headersType,
    setHeadersType,
    headers,
    setHeaders,
    message,
    setMessage,
    reportsData,
    setReportsData,
    reportsCount,
    setReportsCount,
    customReportDetails,
    fetchCustomReports,
    getCustomReportData,
    downloadCustomReportCsv,
    downloadCustomReportPdf,
    getReportFilterList: getReportFilterList,
    reportFilterList,
    setReportFilterList,
    reportOtherFilterList,
    setReportOtherFilterList,
    hasTagFilter,
    setHasTagFilter,
    scheduleCustomReport,bulkDeleteCustomReport
  }

  return <CustomReportContext.Provider value={values}>{children}</CustomReportContext.Provider>
}

export { CustomReportContext, CustomReportProvider }
